<span class="badge {{ BadgeStyleMapper.getClass(badgeStyle)}} size-{{ BadgeSize[this.size].toLowerCase() }}">
  <ng-content></ng-content>
</span>
